import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';  // Ensure this imports correctly
import ResultsPage from './ResultsPage';  // Ensure this imports correctly

function App() {
  return (
    <Router>
      <div className="App bg-gray-100 min-h-screen flex flex-col items-center p-8">
        <Routes>
          <Route path="/" element={<Home />} />  // Changed to use `element` prop
          <Route path="/results" element={<ResultsPage />} />  // Changed to use `element` prop
        </Routes>
      </div>
    </Router>
  );
}

export default App;
